// src/components/shared/PrintButton.tsx
// DROP 42A — Reusable Print Button
// Matches ERUE dark theme — inline style only (no Tailwind)

import React from "react";
import { Printer } from "lucide-react";

interface PrintButtonProps {
  onClick: () => void;
  label?: string;
  size?: "sm" | "md" | "lg";
  variant?: "gold" | "ghost" | "green";
  fullWidth?: boolean;
  disabled?: boolean;
}

const SIZES = {
  sm: { padding: "5px 12px", fontSize: 11, iconSize: 11 },
  md: { padding: "8px 18px", fontSize: 13, iconSize: 13 },
  lg: { padding: "11px 24px", fontSize: 14, iconSize: 14 },
};

const VARIANTS = {
  gold:  { background: "#C9A84C", color: "#070D0A", border: "none" },
  ghost: { background: "rgba(201,168,76,0.1)", color: "#C9A84C", border: "1px solid rgba(201,168,76,0.4)" },
  green: { background: "rgba(15,81,50,0.3)", color: "#4ADE80", border: "1px solid rgba(15,81,50,0.6)" },
};

export default function PrintButton({
  onClick,
  label = "Print",
  size = "md",
  variant = "ghost",
  fullWidth = false,
  disabled = false,
}: PrintButtonProps) {
  const s = SIZES[size];
  const v = VARIANTS[variant];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title="Print / Save as PDF"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: s.padding,
        fontSize: s.fontSize,
        fontWeight: 700,
        fontFamily: "Plus Jakarta Sans, sans-serif",
        borderRadius: 7,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        transition: "opacity 0.15s",
        width: fullWidth ? "100%" : undefined,
        justifyContent: fullWidth ? "center" : undefined,
        ...v,
      }}
    >
      <Printer size={s.iconSize} />
      {label}
    </button>
  );
}
